export default __webpack_public_path__ + "src/assets/bullishIndicator.b99438bea84afbcd9c47fd98cdc0de95.svg";